// extracted by mini-css-extract-plugin
module.exports = {"cell-data-list":"CellData_cell-data-list___xs_r"};